import { Box } from "@mui/material";
import PolicyIcon from "@mui/icons-material/Policy";
import DownloadIcon from "@mui/icons-material/Download";
import { ArrayField, Datagrid, FunctionField, TextField, useNotify, useRecordContext } from "react-admin";
import { settings } from "app";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { getFileFromUrl, previewFileFromUrl } from "server/components/DownloadFile";
import LoadingActionButton from "server/components/LoadingActionButton";
import { doctoralRequests } from "api/doctoralApi";
import AddDocumentDialog from "../../Partials/AddDocumentDialog";
import DoctoralDateField from "../../Partials/DoctoralDateField";

const fileUrl = documentId => `${settings.gatewayApi}/document/private-documents/${documentId}`;

const DocumentsSection = () => {
  const record = useRecordContext();
  const notify = useNotify();

  if (!record?.id) return null;

  const candidacyRows = (record.candidacyDocuments ?? []).flatMap(group =>
    (group.documentIds ?? []).map(documentId => ({
      id: `candidacy-${documentId}`,
      name: group.name,
      documentId,
      createdOn: null,
    })),
  );

  const doctorantRows = (record.documents ?? []).map(document => ({
    id: `doctorant-${document.id}`,
    name: document.name,
    documentId: document.documentId,
    createdOn: document.createdOn,
  }));

  const rows = [...candidacyRows, ...doctorantRows];

  return (
    <Box>
      <SecuredComponent permission={permissions.canUpdateDoctorants}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
          <AddDocumentDialog url={doctoralRequests.addDoctorantDocument(record.id)} />
        </Box>
      </SecuredComponent>

      <ArrayField record={{ ...record, documentRows: rows }} source="documentRows">
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
          empty={<em>Няма прикачени документи</em>}
          sx={settings.style.secondaryDatagrid}
        >
          <TextField source="name" label="Документ" sortable={false} />
          <DoctoralDateField source="createdOn" label="Добавен на" />
          <FunctionField
            label=""
            render={row => (
              <>
                <LoadingActionButton
                  label="Виж"
                  icon={<PolicyIcon />}
                  onClick={() => previewFileFromUrl(fileUrl(row.documentId), `file-${row.documentId}`, notify)}
                />
                <LoadingActionButton
                  label="Изтегли"
                  icon={<DownloadIcon />}
                  onClick={() => getFileFromUrl(fileUrl(row.documentId), `file-${row.documentId}`, notify)}
                />
              </>
            )}
          />
        </Datagrid>
      </ArrayField>
    </Box>
  );
};

export default DocumentsSection;
